<template>
  <component :is="tag" class="section-title">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'SectionTitle',

  props: {
    size: {
      type: Number,
      default: 1
    }
  },

  computed: {
    tag () {
      return `h${this.size}`
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles/variables.sass'

.section-title
  max-width: 70%

h1,
h2
  font-size: $font-size-lg

h3,
h4
  font-size: $font-size
</style>
